import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function DineshLogin() {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        const correctPassword = "Rdr@9518"; // Replace in production

        if (password === correctPassword) {
            const expiryMinutes = 30;
            const expiryTime = new Date().getTime() + expiryMinutes * 60 * 1000;

            sessionStorage.setItem("isDineshAuthenticated", "true");
            sessionStorage.setItem("dineshAuthExpiry", expiryTime.toString());

            navigate("/Dinesh/admin");
        } else {
            setError("Incorrect password. Please try again.");
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 font-sans relative">
            <div className="transform -translate-y-10 w-full max-w-md bg-white rounded-2xl shadow-lg p-6 sm:p-10">
                <h1 className="text-2xl font-bold text-center text-[#785f14] mb-6">
                    Admin Access
                </h1>

                <p className="text-sm text-gray-600 mb-6 text-center">
                    This area is restricted. Please enter the admin password to continue.
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <label className="block text-sm font-medium text-gray-700">
                        <input
                            type="password"
                            placeholder="••••••••"
                            className="mt-1 block w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#785f14] focus:border-[#785f14]"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </label>

                    {error && <p className="text-sm text-red-500">{error}</p>}

                    <button
                        type="submit"
                        className="
              w-full
              inline-flex items-center justify-center
              px-6 py-2.5
              rounded-lg
              bg-gradient-to-r from-brand to-brand-hover
              text-white font-medium tracking-wide
              shadow-md hover:shadow-lg
              transition
              hover:scale-[1.02] active:scale-95
              focus:outline-none focus-visible:ring-2 focus-visible:ring-brand
            "
                    >
                        Unlock Admin Panel
                    </button>
                </form>

            </div>
        </div>
    );
}
